import Vue from 'vue'
import App from './App.vue'
import router from './router'
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
import Swiper from 'swiper';
// import Swiper styles
// import 'swiper/css';
import 'swiper/swiper-bundle.css';

const swiper = new Swiper();


Vue.config.productionTip = false
// 1. 引入实例
import axios from './axios/axios_config.js'
// 因为我在 axios 文件夹下只创建了一个 index.js 文件，那么 webpack 会默认把该文件打包，所以这里的路径可以不用加上 '/index.js' 
// 如果你创建的文件名不是 index，那么一定要加上文件名
// 如果你的 axios 配置文件跟我创建的路径不一样，那么按照你的路径引入就可以了

// 2. 与Vue实例关联
Vue.prototype.$axios = axios
AOS.init();
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
